import axios from "./axios";

export type EcosystemLocale = "tr" | "en";

export interface EcosystemLinkInput {
  label: string;
  href: string;
}

export interface EcosystemFactInput {
  label: string;
  value: string;
  hint?: string | null;
}

export interface EcosystemSectionInput {
  id: string;
  title: string;
  summary: string;
  body: string;
  highlights: string[];
  links: EcosystemLinkInput[];
  facts?: EcosystemFactInput[];
  steps?: string[];
  rules?: string[];
  pitfalls?: string[];
}

export interface EcosystemFaqInput {
  id: string;
  question: string;
  answer: string;
}

export interface EcosystemPagePayload {
  title: string;
  subtitle: string;
  sections: EcosystemSectionInput[];
  faq: EcosystemFaqInput[];
}

export interface InfoMarkerItemInput {
  markerKey: string;
  shortText: string;
  detailText: string;
  anchor: string;
}

export interface InfoMarkerPayload {
  items: InfoMarkerItemInput[];
}

export interface EcosystemDraftResponse<TPayload> {
  locale: EcosystemLocale;
  draft: TPayload;
  published: TPayload;
  updatedAtUtc: string;
  publishedAtUtc?: string | null;
}

export async function getAdminEcosystemPage(locale: EcosystemLocale): Promise<EcosystemDraftResponse<EcosystemPagePayload>> {
  const response = await axios.get("/admin/ecosystem-page", { params: { locale } });
  return response.data as EcosystemDraftResponse<EcosystemPagePayload>;
}

export async function saveAdminEcosystemPage(locale: EcosystemLocale, payload: EcosystemPagePayload): Promise<boolean> {
  const response = await axios.post("/admin/ecosystem-page", { payload }, { params: { locale } });
  return Boolean(response.data?.success);
}

export async function getAdminEcosystemMarkers(locale: EcosystemLocale): Promise<EcosystemDraftResponse<InfoMarkerPayload>> {
  const response = await axios.get("/admin/ecosystem-markers", { params: { locale } });
  return response.data as EcosystemDraftResponse<InfoMarkerPayload>;
}

export async function saveAdminEcosystemMarkers(locale: EcosystemLocale, payload: InfoMarkerPayload): Promise<boolean> {
  const response = await axios.post("/admin/ecosystem-markers", { payload }, { params: { locale } });
  return Boolean(response.data?.success);
}

export async function publishAdminEcosystem(locale: EcosystemLocale): Promise<boolean> {
  const response = await axios.post("/admin/ecosystem/publish", null, { params: { locale } });
  return Boolean(response.data?.success);
}
